import axios from "axios";
import { serviceBaseUrl } from "./constants";

export const matchesService = {
  getAllMatchesForTeam: async (seasonId: string, teamId: string) => {
    const response = await axios.get(
      `${serviceBaseUrl}/matchSetupForTeam/${seasonId}/${teamId}`
    );
    return response.data;
  },

  updateMatchWithSelectedPlayers: async (
    matchId: string,
    selectedPlayersInTeam: any
  ) => {
    const response = await axios.post(
      `${serviceBaseUrl}/updatePlayerSelections/${matchId}`,
      selectedPlayersInTeam
    );
    return response.data;
  },

  getAllMatchSetups: async (seasonId: string) => {
    const response = await axios.get(
      `${serviceBaseUrl}/matchSetupBySeason/${seasonId}`
    );
    return response.data;
  },
  getInProgressMatchSetup: async (seasonId: string) => {
    const response = await axios.get(
      `${serviceBaseUrl}/getInProgressMatchConfig/${seasonId}`
    );
    return response.data;
  }
};
